'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStore;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _clientMiddleware = require('./middleware/clientMiddleware');

var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);

var _userAuthMiddleware = require('./middleware/userAuthMiddleware');

var _userAuthMiddleware2 = _interopRequireDefault(_userAuthMiddleware);

var _errorMiddleware = require('./middleware/errorMiddleware');

var _errorMiddleware2 = _interopRequireDefault(_errorMiddleware);

var _filterMiddleware = require('./middleware/filterMiddleware');

var _filterMiddleware2 = _interopRequireDefault(_filterMiddleware);

var _timerMiddleware = require('./middleware/timerMiddleware');

var _timerMiddleware2 = _interopRequireDefault(_timerMiddleware);

var _catalogMiddleware = require('./middleware/catalogMiddleware');

var _catalogMiddleware2 = _interopRequireDefault(_catalogMiddleware);

var _shopMiddleware = require('./middleware/shopMiddleware');

var _shopMiddleware2 = _interopRequireDefault(_shopMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore(history, client, ibonus, data) {
    // Sync dispatched route actions to the history
    var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);

    var middleware = [(0, _clientMiddleware2.default)(client, ibonus), (0, _errorMiddleware2.default)(), (0, _timerMiddleware2.default)(), (0, _userAuthMiddleware2.default)(ibonus), (0, _filterMiddleware2.default)(ibonus), (0, _catalogMiddleware2.default)(ibonus), (0, _shopMiddleware2.default)(client, ibonus), reduxRouterMiddleware];

    var finalCreateStore = void 0;
    if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
        var _require = require('redux-devtools'),
            persistState = _require.persistState;

        var DevTools = require('../containers/DevTools/DevTools');
        finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
    } else {
        finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
    }

    var reducer = require('./reducer');
    var store = finalCreateStore(reducer, data);

    if (__DEVELOPMENT__ && module.hot) {
        module.hot.accept('./reducer', function () {
            store.replaceReducer(require('./reducer'));
        });
    }

    return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 1885
// module chunks = 0